import React from 'react'
import { Form } from 'react-aria-components'

import { css } from '@portal/styled-system/css'

import type { UserInfo } from '@/entities/chat'
import { useI18n } from '@/shared/lib/i18n'
import { Button, CancelButton, Checkbox, Modal, type ModalProps } from '@/shared/ui'

import { usePublicProfileInfo } from '../../hooks'
import { type DialogParams, type FormValues, FormValuesSchema } from './types'

export type MessageHideDialogProps = (ModalProps & DialogParams) & {
    reporter: UserInfo | null
    onHideClick: (values: FormValues & DialogParams) => void
    nonInteractive?: boolean
}

export function MessageHideDialog(props: MessageHideDialogProps) {
    const { channel, message_id, author_id, reporter, onClose, nonInteractive, onHideClick, ...modalProps } = props
    const { i18n } = useI18n()

    const isBanCheckboxVisible = author_id !== reporter?.user_id && reporter?.role === 'admin'

    const author = usePublicProfileInfo(author_id)

    return (
        <Modal {...modalProps} styles={css.raw({ width: '[25rem]' })}>
            <Modal.CloseButton onClose={props.onClose} />
            <Modal.Header styles={css.raw({ backgroundColor: 'primary' })} icon="fa-solid fa-crab">
                {i18n.CHAT_HIDE_MESSAGE__TITLE}
            </Modal.Header>
            <Modal.Body styles={css.raw({ alignItems: 'flex-start' })}>
                <Form
                    method="post"
                    onSubmit={(evt) => {
                        evt.preventDefault()
                        const formData = new FormData(evt.currentTarget as HTMLFormElement)
                        const formValues = FormValuesSchema.parse(formData)

                        onHideClick({ channel, message_id, author_id, ...formValues })
                    }}
                    className={css({ width: 'full', display: 'flex', flexDirection: 'column', gap: '3' })}
                >
                    {isBanCheckboxVisible && <Checkbox name="ban">{i18n.CHAT_HIDE_MESSAGE__MUTE}</Checkbox>}
                    {/* NOTE: Саппорту сейчас не нужны эти кнопки, они из админки модерируют, наверное был задел на модераторов-игроков, которые без админки */}
                    {/* NOTE: на бэкенде этот параметр ни на что не влияет */}
                    {/* <Checkbox name="report">{i18n.CHAT_HIDE_MESSAGE__SPAM}</Checkbox> */}
                    <Checkbox name="deleteAll">
                        <span>
                            {replaceI18nParam(
                                i18n.CHAT_HIDE_MESSAGE__HIDE_ALL,
                                '{string01}',
                                <b>{author?.nick ?? author_id}</b>
                            )}
                        </span>
                    </Checkbox>
                    <Modal.Buttons styles={css.raw({ justifyContent: 'flex-end', padding: '0', paddingTop: '3' })}>
                        <CancelButton styles={css.raw({ width: 'auto' })} onPress={onClose} />
                        <Button type="submit" color="success" isDisabled={nonInteractive}>
                            {i18n.CHAT_HIDE_MESSAGE__BTN_HIDE}
                        </Button>
                    </Modal.Buttons>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

function replaceI18nParam(text: string, param: string, element: React.ReactElement<any>) {
    const [before, after] = text.split(param)

    return (
        <React.Fragment>
            {before}
            {element}
            {after}
        </React.Fragment>
    )
}
